import { ApiBase } from "./api-base";

export class HttpChannelApi extends ApiBase {
  onApiName(): string {
    return "ChannelApi";
  }

  onUrlPath(): string {
    return "/channel";
  }

  public async post(param: any) {
    const response = await this.requestPost(param);
    return response;
  }
}
